import { Component, Vue } from 'vue-property-decorator';
import template from './week-overview.vue';
import { readableDate } from '@/utilities';
import { nl, enUS } from 'date-fns/locale';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { getWeek } from 'date-fns';

@Component({
  mixins: [template],
})
export default class WeekOverview extends Vue {
  year = new Date().getFullYear();
  week: number = 0;
  weekNr: number = getWeek(new Date(), { firstWeekContainsDate: 4 });
  overview: any[] = [];

  mounted() {
    this.year = this.weekNr > 50 && new Date().getMonth() === 0 ? this.year - 1 : this.year;
    this.getData();
  }

  async getData() {
    try {
      await apiService.getWeekOverview(this.week, this.year);
      if (this.$Store.state.weekOverview.length) {
        this.weekNr = getWeek(new Date(this.$Store.state.weekOverview[0].date), { firstWeekContainsDate: 4 });
        this.getOverview();
      }
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.week_overview.retrieve_error', type: 'danger' });
    }
  }

  setWeek(add: number): void {
    this.week += add;
    this.weekNr += add;
    this.getData();
  }

  getOverview(): void {
    const overview = this.$Store.state.weekOverview;
    this.overview = [];
    overview.forEach((o, oi) => {
      this.overview.push({
        id: `${oi + 1}`,
        isDate: true,
        date: o.date
      });
      if (!o.appointmentsByUser.length) {
        this.overview.push({ id: `${oi}0`, isEmpty: true });
      }
      o.appointmentsByUser.forEach((u, ui) => {
        u.appointments.forEach((a, ai) => {
          this.overview.push({
            id: `${oi}${ui}${ai}`,
            name: ai ? '' : u.name,
            startTime: a.startTime,
            endTime: a.endTime,
            seat: a.seat,
            joinsLunch: a.joinsLunch
          });
        });
      });
    });
  }

  getReadableDate(date: string): string {
    return readableDate(new Date(date), this.$i18n.locale === 'nl' ? nl : enUS);
  }
}